// extracted by mini-css-extract-plugin
export default {"departments":"EF-z","departmentHeading":"FF-z","departmentSection":"GF-z","departmentName":"HF-z","departmentLink":"IF-z","expandIcon":"JF-z"};